import { z } from 'zod';

const isDev = import.meta.env.DEV;

const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1).default('MatchRoom'),
  VITE_APP_TAGLINE: z.string().default('Watch Together. Cheer Together.'),
  VITE_API_URL: z.string().default(''),
  VITE_SOCKET_URL: z.string().default(''),
  VITE_APP_VERSION: z.string().default('0.1.0'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid frontend environment variables:', parsed.error.flatten().fieldErrors);
}

const raw = parsed.success
  ? parsed.data
  : {
      VITE_APP_NAME: 'MatchRoom',
      VITE_APP_TAGLINE: 'Watch Together. Cheer Together.',
      VITE_API_URL: '',
      VITE_SOCKET_URL: '',
      VITE_APP_VERSION: '0.1.0',
    };

function requireProductionUrl(value: string, key: string): string {
  if (!value) {
    throw new Error(`${key} must be set for production builds. Configure it in Vercel project settings.`);
  }
  const result = z.string().url().safeParse(value);
  if (!result.success) {
    throw new Error(`${key} must be a valid URL. Received: "${value}"`);
  }
  return value;
}

/** Validated environment — production requires VITE_API_URL and VITE_SOCKET_URL. */
export const env = isDev
  ? raw
  : {
      ...raw,
      VITE_API_URL: requireProductionUrl(raw.VITE_API_URL, 'VITE_API_URL'),
      VITE_SOCKET_URL: requireProductionUrl(raw.VITE_SOCKET_URL, 'VITE_SOCKET_URL'),
    };

export type Env = typeof env;
